import { render } from "./MapLegend.vue?vue&type=template&id=58d9cb46&scoped=true"
import script from "./MapLegend.vue?vue&type=script&lang=ts"
export * from "./MapLegend.vue?vue&type=script&lang=ts"

import "./MapLegend.vue?vue&type=style&index=0&id=58d9cb46&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-58d9cb46"

export default script